import * as React from 'react';
import Menu from 'shared/components/Menu';
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'
import MinimizeMenuButton from 'shared/components/MinimizeBarButton'

interface SidebarProps {
    brandContent?: React.FunctionComponent | React.ReactElement | string | false
    showMinimizeBarButton?: boolean
}

const Sidebar: React.FunctionComponent<SidebarProps> = (props) => {

    const activeRoute = (routeName: string) => {
        return window.location.pathname.indexOf(routeName) > -1 ? "active" : "";
    };

    return (
        <div
            className="sidebar"
        >
            <div className="brand-content">
                {props.brandContent}
            </div>
            <div className="sidebar-wrapper">
                <PerfectScrollbar>
                    <Menu position="left" showLogOut={true} />
                </PerfectScrollbar>
                {props.showMinimizeBarButton && <MinimizeMenuButton />}
            </div>
        </div>
    );
}

export default Sidebar;